import styled, { css, keyframes } from "styled-components";
import { LIGHT_GRAY, LOW_BLUE, NEAR_WHITE, OPAQUE_LIGHT_BLUE } from "../../config";
import { SecondaryButton } from "../Button";

export const ArrowContainer = styled.button<{ disabled?: boolean }>`
  cursor: pointer;
  color: ${NEAR_WHITE};
  background: transparent;

  margin: 0px 16px;
  padding: 0;
  border: 0;

  &:hover {
    color: ${LOW_BLUE};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${LIGHT_GRAY};
      cursor: not-allowed;
      &:hover {
        color: ${LIGHT_GRAY};
        cursor: not-allowed;
      }
    `}
`;

export const PaginationContainer = styled.div`
  color: ${NEAR_WHITE};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: inline-flex;
  margin-right: 16px;
`;

export const PlayAnimation = keyframes`
  from {
    border: 1px solid ${LOW_BLUE};
    color: ${LOW_BLUE}
  }
  to {
    border: 1px solid ${OPAQUE_LIGHT_BLUE}; 
    color: ${OPAQUE_LIGHT_BLUE}
  }
`;

export const PlayButton = styled(SecondaryButton) <{ automaticPagingOn?: boolean }>`
  ${({ automaticPagingOn }) =>
    automaticPagingOn &&
    css`
      animation: ${PlayAnimation} 1s linear infinite alternate-reverse;
    `}
`;

export const PlayButtonContainer = styled.div<{ disabled?: boolean }>`
  align-items: center;
  justify-content: center;
  display: inline-flex;
  cursor: pointer;
  color: ${NEAR_WHITE};
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;
  margin: 0px 10px;

  &:hover {
    color: ${LOW_BLUE};
  }
`;
